import { Text } from '@chakra-ui/react'

export function ResultsSummary({ totalPedidos, totalItens, totalPecas }) {
  return (
    <Text fontSize="12px" color="#313E44" mb={4}>
      {totalPedidos} Pedidos - {totalItens} itens - {totalPecas.toLocaleString('pt-BR')} peças
    </Text>
  )
}
